export type PeriodPresetId = "mtd" | "ytd" | "custom";

export interface PeriodRange {
    start: Date;
    end: Date;
}

export interface CustomPeriodInput {
    start?: string;
    end?: string;
}

const startOfDay = (date: Date): Date => {
    const copy = new Date(date);
    copy.setHours(0, 0, 0, 0);
    return copy;
};

/** Resolve o preset selecionado (ou a janela custom) em datas concretas, sempre em granularidade diária. */
export function computePeriodRange(presetId: PeriodPresetId, custom?: CustomPeriodInput): PeriodRange {
    const now = new Date();
    const today = startOfDay(now);

    switch (presetId) {
        case "mtd":
            return { start: new Date(today.getFullYear(), today.getMonth(), 1), end: now };
        case "ytd":
            return { start: new Date(today.getFullYear(), 0, 1), end: now };
        case "custom": {
            const parsedStart = custom?.start ? startOfDay(new Date(custom.start)) : today;
            const parsedEnd = custom?.end ? startOfDay(new Date(custom.end)) : today;
            const [start, end] = parsedStart <= parsedEnd ? [parsedStart, parsedEnd] : [parsedEnd, parsedStart];
            return { start, end };
        }
        default:
            return { start: today, end: now };
    }
}

export const toDateInputValue = (date: Date): string => date.toISOString().slice(0, 10);

/**
 * Interpreta ISO como data local, não UTC. `new Date("2026-08-01")` é meia-noite UTC, que em
 * UTC-3 renderiza 31/07 — todo rótulo de eixo sairia um dia adiantado. Ancorar ao meio-dia local
 * é a mesma solução do `parseIso` em buildExecutionTimeline.ts.
 */
const parseIsoAsLocalDay = (iso: string): Date => {
    const dayOnly = /^\d{4}-\d{2}-\d{2}$/.test(iso.trim());
    return new Date(dayOnly ? `${iso.trim()}T12:00:00` : iso);
};

export const formatAxisDate = (iso: string): string =>
    parseIsoAsLocalDay(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });

export const formatTooltipDate = (iso: string): string =>
    parseIsoAsLocalDay(iso).toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
    });
